import type { IconSvgObject } from './types';

const InspectCodeIcon: IconSvgObject = [
  ["path", { d: "M17.5 17.5L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 9.5L16 11L14.5 12.5", fill: "currentColor", key: "2" }],
  ["path", { d: "M7.5 9.5L6 11L7.5 12.5", fill: "currentColor", key: "3" }],
  ["path", { d: "M12 8.5L10 13.5L12 8.5Z", fill: "currentColor", key: "4" }],
  ["path", { d: "M14.5 9.5L16 11L14.5 12.5M7.5 9.5L6 11L7.5 12.5M12 8.5L10 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default InspectCodeIcon;
